import * as sdk from '@cypro/server/sdk'
import {queryOptions, useSuspenseQuery} from '@tanstack/react-query'

export type Licence = sdk.GetLicenceStateResponse

export const getLicenceStateOptions = queryOptions({
  queryKey: ['licence-state'],
  queryFn: async () => {
    const {error, data} = await sdk.getLicenceState()
    if (error) throw error
    return data
  },
  staleTime: 5 * 60 * 1000,
})

export function useGetLicenceState() {
  const {data, ...rest} = useSuspenseQuery(getLicenceStateOptions)
  return {
    ...rest,
    licence: data ?? null,
  }
}

/** The organisation country (ISO 3166-1 alpha-2) declared in the licence, if any. */
export function useLicenceCountry() {
  const {licence} = useGetLicenceState()
  return licence?.payload?.details?.country || undefined
}
